import React, { useState } from 'react';
import { createApplication } from '../firebase';
import './ContactUs.css';

function ContactUs() {
  const [formData, setFormData] = useState({
    applicationType: 'Artist', // Default selection
    name: '',
    email: '',
    websiteLink: '',
    message: '',
    acceptTerms: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleApplicationTypeChange = (type) => {
    setFormData({
      ...formData,
      applicationType: type
    });
  };

  const handleInputChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value
    });
  };

  const handleSubmit = async () => {
    // Validation
    if (!formData.name.trim()) {
      setSubmitMessage('Please enter your name');
      return;
    }
    
    if (!formData.email.trim()) {
      setSubmitMessage('Please enter your email');
      return;
    }
    
    if (!formData.acceptTerms) {
      setSubmitMessage('Please accept the terms of use');
      return;
    }
    
    setIsSubmitting(true);
    setSubmitMessage('');
    
    try {
      // Prepare data for Firebase
      const applicationData = {
        applicationType: formData.applicationType,
        name: formData.name.trim(),
        email: formData.email.trim(),
        websiteLink: formData.websiteLink.trim(),
        message: formData.message.trim(),
        acceptTerms: formData.acceptTerms
      };
      
      // Save to Firebase Realtime Database
      const result = await createApplication(applicationData);
      
      if (result.error) {
        setSubmitMessage(`Error: ${result.error}`);
      } else {
        setSubmitMessage('Application submitted successfully! We will get back to you soon.');
        
        // Reset form
        setFormData({
          applicationType: 'Artist',
          name: '',
          email: '',
          websiteLink: '',
          message: '',
          acceptTerms: false
        });
      }
    } catch (error) {
      setSubmitMessage(`Error: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-us">
      {/* Contact Section Title */}
      <h2 className="contact-section-title">Partner with Song Audit</h2>
      
      <div className="contact-us-content">
        {/* Logo Icon */}
        <div className="contact-logo-icon">
          <img src="/img/audit_icon.webp" alt="Song Audit Logo" className="contact-logo-image" />
        </div>

        <h2 className="contact-title">JOIN AS</h2>

        {/* Application Type Buttons */}
        <div className="application-types">
          <button 
            className={`application-type-btn ${formData.applicationType === 'Artist' ? 'active' : ''}`}
            onClick={() => handleApplicationTypeChange('Artist')}
          >
            Artist
          </button>
          <button 
            className={`application-type-btn ${formData.applicationType === 'Label' ? 'active' : ''}`}
            onClick={() => handleApplicationTypeChange('Label')}
          >
            Label
          </button>
          <button 
            className={`application-type-btn ${formData.applicationType === 'Distributor' ? 'active' : ''}`}
            onClick={() => handleApplicationTypeChange('Distributor')}
          >
            Distributor
          </button>
        </div>

        {/* Form Fields */}
        <div className="contact-form">
          <input
            type="text"
            placeholder="NAME / ARTIST NAME / LABEL NAME"
            value={formData.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
            className="contact-input"
          />

          <input
            type="email"
            placeholder="EMAIL"
            value={formData.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
            className="contact-input"
          />

          <input
            type="url"
            placeholder="SPOTIFY ARTIST / LABEL PROFILE OR WEBSITE"
            value={formData.websiteLink}
            onChange={(e) => handleInputChange('websiteLink', e.target.value)}
            className="contact-input"
          />

          <textarea
            placeholder="TELL US ABOUT YOUR CATALOG AND REVENUE GOALS"
            value={formData.message}
            onChange={(e) => handleInputChange('message', e.target.value)}
            className="contact-textarea"
            rows={6}
          />

          {/* Terms Checkbox */}
          <div className="contact-terms">
            <input
              type="checkbox"
              id="acceptTerms"
              checked={formData.acceptTerms}
              onChange={(e) => handleInputChange('acceptTerms', e.target.checked)}
              className="contact-checkbox"
            />
            <label htmlFor="acceptTerms" className="contact-terms-label">
              I ACCEPT THE TERMS OF USE & PRIVACY POLICY
            </label>
          </div>

          {/* Submit Message */}
          {submitMessage && (
            <div className={`contact-submit-message ${submitMessage.includes('Error') ? 'error' : 'success'}`}>
              {submitMessage}
            </div>
          )}

          {/* Submit Button */}
          <button 
            className="contact-submit-btn" 
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'SUBMITTING...' : 'START AUDIT PARTNERSHIP'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContactUs; 